__webpack_require__.O(0, ["main"], function() {
	__webpack_require__.E("salvage");
}, 5);